import {
    peopleFeedbackSubmitSearchFeedback,
    LinkedInBindingButtonText,
} from './SuggestionsHeaderFooterInfo.locstring.json';
import { findRecipientInfo_UseThisAddress } from 'owa-locstrings/lib/strings/findrecipientinfo_usethisaddress.locstring.json';
import { findRecipientInfo_NoResultsFound } from 'owa-locstrings/lib/strings/findrecipientinfo_noresultsfound.locstring.json';
import { findRecipientInfo_TopNResults } from 'owa-locstrings/lib/strings/findrecipientinfo_topnresults.locstring.json';
import { findRecipientInfo_SearchDirectory } from 'owa-locstrings/lib/strings/findrecipientinfo_searchdirectory.locstring.json';
import { findRecipientInfo_SearchPeople } from 'owa-locstrings/lib/strings/findrecipientinfo_searchpeople.locstring.json';
import { findRecipientInfo_TypeToSearch } from 'owa-locstrings/lib/strings/findrecipientinfo_typetosearch.locstring.json';
import { findRecipientInfo_Searching } from 'owa-locstrings/lib/strings/findrecipientinfo_searching.locstring.json';
import { findRecipientResult_SuggestedContactsHeader } from 'owa-locstrings/lib/strings/findrecipientresult_suggestedcontactsheader.locstring.json';
import loc, { format } from 'owa-localize';
import { getStyles } from './SuggestionsHeaderFooterInfo.styles';
import { ITheme } from '@uifabric/styling';
import { classNamesFunction } from '@uifabric/utilities';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { Spinner } from 'office-ui-fabric-react/lib/Spinner';
import { ControlIcons } from 'owa-control-icons';
import { getExtendedTheme } from 'owa-fabric-theme';
import { FindRecipientInfoType } from 'owa-recipient-common/lib/components/FindRecipientInfo';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';

import * as React from 'react';
import {
    SuggestionsHeaderFooterInfoProps,
    SuggestionsHeaderFooterInfoStyles,
    SuggestionsHeaderFooterInfoStyleProps,
} from './SuggestionsHeaderFooterInfo.types';
import saveLinkedInBindingDismissed from '../actions/saveLinkedInBindingDismissed';
import { FloatingPeoplePicker } from 'office-ui-fabric-react/lib/FloatingPicker';

const getClassNames = classNamesFunction<
    SuggestionsHeaderFooterInfoStyleProps,
    SuggestionsHeaderFooterInfoStyles
>();

let classNamesUtil = require('classnames');

const SuggestionsHeaderFooterInfo = (props: SuggestionsHeaderFooterInfoProps) => {
    let {
        infoType,
        queryString,
        picker,
        numberOfResults,
        theme = getExtendedTheme() as ITheme,
    } = props;
    const classNames = getClassNames(getStyles, { theme: theme });
    switch (infoType) {
        case FindRecipientInfoType.SuggestedContacts:
            return (
                <div
                    className={classNamesUtil(
                        classNames.textContainer,
                        classNames.suggestedContactsHeaderBox
                    )}>
                    <span className={classNames.suggestedContactsText}>
                        {loc(findRecipientResult_SuggestedContactsHeader)}
                    </span>
                </div>
            );
        case FindRecipientInfoType.Searching:
            return (
                <div className={classNamesUtil(classNames.footerBorder, classNames.container)}>
                    <div className={classNames.iconContainer}>
                        <Spinner theme={theme} />
                    </div>
                    <div className={classNames.textContainer}>
                        {format(loc(findRecipientInfo_Searching), queryString)}
                    </div>
                </div>
            );
        case FindRecipientInfoType.TypeToSearch:
            return (
                <div className={classNames.container}>
                    <div className={classNamesUtil(classNames.textContainer, classNames.centered)}>
                        {loc(findRecipientInfo_TypeToSearch)}
                    </div>
                </div>
            );
        case FindRecipientInfoType.SearchDirectory:
            return (
                <div className={classNamesUtil(classNames.footerBorder, classNames.container)}>
                    <div className={classNames.iconContainer}>
                        <Icon className={classNames.searchIcon} iconName={ControlIcons.Search} />
                    </div>
                    <div className={classNames.textContainer}>
                        {isConsumer()
                            ? loc(findRecipientInfo_SearchPeople)
                            : loc(findRecipientInfo_SearchDirectory)}
                    </div>
                </div>
            );
        case FindRecipientInfoType.TopNResults:
            return (
                <div className={classNamesUtil(classNames.footerBorder, classNames.container)}>
                    <div className={classNamesUtil(classNames.textContainer, classNames.centered)}>
                        {numberOfResults
                            ? format(loc(findRecipientInfo_TopNResults), numberOfResults)
                            : loc(findRecipientInfo_NoResultsFound)}
                    </div>
                </div>
            );
        case FindRecipientInfoType.UseAddress:
            return (
                <div
                    className={classNamesUtil(
                        classNames.headerBorder,
                        classNames.textContainer,
                        classNames.useAddressContainer
                    )}>
                    {format(loc(findRecipientInfo_UseThisAddress), queryString)}
                </div>
            );
        case FindRecipientInfoType.FindPeopleFeedback:
            return (
                <div
                    className={classNamesUtil(
                        classNames.footerBorder,
                        classNames.textContainer,
                        classNames.feedbackContainer
                    )}>
                    <Icon className={classNames.feedbackInfoIcon} iconName={ControlIcons.Info} />
                    {loc(peopleFeedbackSubmitSearchFeedback)}
                </div>
            );
        case FindRecipientInfoType.LinkedInAccountBind:
            return (
                <div
                    className={classNamesUtil(
                        classNames.footerBorder,
                        classNames.linkedInBindContainer,
                        classNames.container
                    )}>
                    <Icon
                        className={classNamesUtil(
                            classNames.linkedInIcon,
                            classNames.verticalCenter
                        )}
                        iconName={ControlIcons.LinkedInLogo}
                    />
                    <span
                        className={classNamesUtil(
                            classNames.linkedInBindText,
                            classNames.verticalCenter
                        )}>
                        {loc(LinkedInBindingButtonText)}
                    </span>
                    <div
                        className={classNames.linkedinBindingDismiss}
                        onClick={onLinkedInBindingDismiss(picker)}>
                        <Icon className={classNames.cancelIcon} iconName={ControlIcons.Cancel} />
                    </div>
                </div>
            );
        default:
            return null;
    }
};

const onLinkedInBindingDismiss = (picker: FloatingPeoplePicker) => {
    return function(ev: React.MouseEvent<unknown>): void {
        ev.stopPropagation();
        saveLinkedInBindingDismissed(picker);
    };
};

export default SuggestionsHeaderFooterInfo;
